
import ViewModel from '@/models/ViewModel'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class CreativePreview extends ViewModel {
  @Prop({ default: '' })
  public creative_id!: string

  @Prop({ default: '2' })
  public defaultFrame!: string

  @Prop({ default: '0' })
  public maxFrames!: string

  public isAnimating = false

  public current_frame = 0

  public timeOutHandle: any = null

  public initialized = false

  public preloaded = false

  public frames: string[] = []

  public get currentImage() {
    return `${this.cdnPath}videos/${this.creative_id}/preview/${this.current_frame}.jpg`
  }

  @Watch('maxFrames')
  public onMaxFramesChanged() {
    this.preloaded = false
    this.frames = []
    this.initialized = false
    this.init()
  }

  public mounted() {
    this.init()
  }

  public init() {
    if (this.maxFrames == '0') {
      this.initialized = true
      return
    }

    this.current_frame = parseInt(this.defaultFrame)

    this.initialized = true
  }

  public startHoverAnimation() {
    if (this.maxFrames == '0') {
      return
    }

    if (!this.preloaded) {
      for (let i = 1; i <= parseInt(this.maxFrames); i++) {
        this.frames.push(`${this.cdnPath}videos/${this.creative_id}/preview/${i}.jpg`)
      }
      this.preloaded = true
    }

    this.isAnimating = true

    this.timeOutHandle = setTimeout(() => {
      this.current_frame = 1

      this.animateFrames()
    }, 500)
  }

  public stopHoverAnimation() {
    if (this.maxFrames == '0') {
      return
    }

    if (this.timeOutHandle) {
      clearTimeout(this.timeOutHandle)
      this.timeOutHandle = null
    }

    this.isAnimating = false
    this.current_frame = parseInt(this.defaultFrame)
  }

  public animateFrames() {
    if (!this.isAnimating) {
      return
    }

    this.current_frame += 1
    if (this.current_frame > parseInt(this.maxFrames)) {
      this.current_frame = 1
    }

    this.timeOutHandle = setTimeout(() => {
      this.animateFrames()
    }, 500)
  }
}
